// Regras de formato da gravação de áudio do chat.
//
// Ficam fora do hook porque são decisões puras — e porque `MediaRecorder` não
// existe no jsdom, então testar a escolha do formato através do hook exigiria
// simular o navegador inteiro para verificar uma lista de preferência.

// Ordem de preferência do formato gravado. Opus é o que rende arquivo menor
// para voz; `audio/webm` sem codec cobre navegadores que aceitam o container
// mas não anunciam o codec; `audio/mp4` existe porque o Safari não grava webm
// de jeito nenhum — sem ele, o microfone simplesmente não funcionaria lá.
//
// Todo formato desta lista precisa estar liberado em `allowed_mime_types` do
// bucket chat-attachments, ou o upload volta erro do Storage.
export const FORMATOS_DE_AUDIO_PREFERIDOS = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4'
];

// O bucket chat-attachments tem teto de 50MB. Sem um limite, uma gravação
// esquecida aberta só falharia no upload — depois de tudo gravado e perdido.
// Cinco minutos de voz em Opus ficam na casa de poucos MB, bem longe do teto.
export const DURACAO_MAXIMA_SEGUNDOS = 300;

const EXTENSAO_POR_CONTAINER: Record<string, string> = {
  'audio/webm': 'webm',
  'audio/ogg': 'ogg',
  // .m4a é o que os players reconhecem como áudio; .mp4 abre como vídeo sem
  // imagem em vários lugares.
  'audio/mp4': 'm4a',
  'audio/mpeg': 'mp3'
};

export function escolherMimeTypeDeAudio(suportado: (tipo: string) => boolean): string | null {
  return FORMATOS_DE_AUDIO_PREFERIDOS.find(tipo => suportado(tipo)) ?? null;
}

// O mime do MediaRecorder vem com os parâmetros de codec ("audio/webm;
// codecs=opus"). O Storage compara o content-type do upload com
// `allowed_mime_types` do bucket, onde só existe o container — com os
// parâmetros, nenhuma entrada casa e o upload é recusado.
export function containerDoMime(mime: string): string {
  return (mime || '').split(';')[0].trim().toLowerCase();
}

export function extensaoDoMimeDeAudio(mime: string): string {
  return EXTENSAO_POR_CONTAINER[containerDoMime(mime)] ?? 'webm';
}

export function nomeDoArquivoDeAudio(mime: string, agora: Date): string {
  // Os dois pontos do ISO saem daqui: o nome entra no caminho do objeto no
  // Storage, que não aceita o caractere.
  const instante = agora.toISOString().replace(/\.\d+Z$/, '').replace(/:/g, '-');
  return `audio-${instante}.${extensaoDoMimeDeAudio(mime)}`;
}

export function formatarDuracaoDeAudio(segundos: number): string {
  const minutos = Math.floor(segundos / 60);
  const resto = segundos % 60;
  return `${String(minutos).padStart(2, '0')}:${String(resto).padStart(2, '0')}`;
}
